export const blockIconsTravelRoomServiceNew = (
	<span className='material-symbols-outlined'>room_service</span>
);
